import { CustomTimestamps } from 'chessboard/api/custom-timestamps/config/types';

/**
 * Convert deciseconds to a time in given units.
 */
export function toUnit(deciseconds: number | null, unit: CustomTimestamps.Units): number | null {
  if (deciseconds === null) {
    return null;
  }

  let time: number;

  switch (unit) {
    case CustomTimestamps.Units.Milliseconds:
      time = deciseconds * 100;
      break;
    case CustomTimestamps.Units.Seconds:
      time = deciseconds * 10;
      break;
    case CustomTimestamps.Units.Deciseconds:
    default:
      time = deciseconds;
      break;
  }

  return time;
}
